import { useParams } from "react-router-dom";

import { useAdministrationStore } from "@modules/administration/administrationStore";

import { useGetZones } from "./useGetZones";

/**
 * Resolves the current zone (from the route param, falling back to the
 * selected zone in the administration store) and returns the list of ancestor
 * zone NAMES for rendering a <ZoneBreadcrumbs /> in list tables.
 */
export function useZoneBreadcrumbPath(): string[] {
  const { zoneId } = useParams();
  const selectedZoneId = useAdministrationStore((s) => s.selectedZoneId);
  const { zones } = useGetZones();

  const zone = zones.find((z) => z.id === (zoneId ?? selectedZoneId));

  if (!zone) {
    return [];
  }

  return zone.path
    .split(".")
    .map((id) => zones.find((z) => z.id === id)?.name)
    .filter((name): name is string => name !== undefined);
}
